import { defaultMessages } from './messages';

import { ChecklistItemId, type ChecklistItem } from './types';

import {
	AUTOMATE_WORK_DARK,
	AUTOMATE_WORK_LIGHT,
	CONNECTOR_DARK,
	CONNECTOR_LIGHT,
	BROWSE_AGENTS_DARK,
	BROWSE_AGENTS_LIGHT,
	DEEP_RESEARCH_DARK,
	DEEP_RESEARCH_LIGHT,
	PROMPT_GALLERY_DARK,
	PROMPT_GALLERY_LIGHT,
	SEARCH_DARK,
	SEARCH_LIGHT,
	STATUS_UPDATE_DARK,
	STATUS_UPDATE_LIGHT,
	INSTALL_EXTENSION_DARK,
	INSTALL_EXTENSION_LIGHT,
} from '../assets';

export const CHECKLIST_ITEMS: ChecklistItem[] = [
	{
		id: ChecklistItemId.writeStatusUpdate,
		iconLight: STATUS_UPDATE_LIGHT,
		iconDark: STATUS_UPDATE_DARK,
		label: defaultMessages.writeStatusUpdateLabel,
		description: defaultMessages.writeStatusUpdateDescription,
	},
	{
		id: ChecklistItemId.connectWorkTools,
		iconLight: CONNECTOR_LIGHT,
		iconDark: CONNECTOR_DARK,
		label: defaultMessages.connectWorkToolsLabel,
		description: defaultMessages.connectWorkToolsDescription,
	},
	{
		id: ChecklistItemId.askRovoFind,
		iconLight: SEARCH_LIGHT,
		iconDark: SEARCH_DARK,
		label: defaultMessages.askRovoFindLabel,
		description: defaultMessages.askRovoFindDescription,
	},
	{
		id: ChecklistItemId.deepResearch,
		iconLight: DEEP_RESEARCH_LIGHT,
		iconDark: DEEP_RESEARCH_DARK,
		label: defaultMessages.deepResearchLabel,
		description: defaultMessages.deepResearchDescription,
	},
	{
		id: ChecklistItemId.promptGallery,
		iconLight: PROMPT_GALLERY_LIGHT,
		iconDark: PROMPT_GALLERY_DARK,
		label: defaultMessages.promptGalleryLabel,
		description: defaultMessages.promptGalleryDescription,
	},
	{
		id: ChecklistItemId.browseAgents,
		iconLight: BROWSE_AGENTS_LIGHT,
		iconDark: BROWSE_AGENTS_DARK,
		label: defaultMessages.browseAgentsLabel,
		description: defaultMessages.browseAgentsDescription,
	},
	{
		id: ChecklistItemId.automateWork,
		iconLight: AUTOMATE_WORK_LIGHT,
		iconDark: AUTOMATE_WORK_DARK,
		label: defaultMessages.automateWorkLabel,
		description: defaultMessages.automateWorkDescription,
	},
	{
		id: ChecklistItemId.installExtension,
		iconLight: INSTALL_EXTENSION_LIGHT,
		iconDark: INSTALL_EXTENSION_DARK,
		label: defaultMessages.installExtensionLabel,
		description: defaultMessages.installExtensionDescription,
	},
];

export const TOTAL_STEPS: number = CHECKLIST_ITEMS.length;
